/**
 * What each CRM is called on screen. One list, so the field-map page, the Prospects page and the
 * integration cards never name the same CRM two ways. A provider this list does not know is shown
 * as it was given rather than hidden.
 */
const CRM_NAMES: Record<string, string> = {
  salesforce: 'Salesforce',
  wealthbox: 'Wealthbox',
  redtail: 'Redtail',
};

export function crmName(provider: string): string {
  return CRM_NAMES[provider] ?? provider;
}
